import { HttpClientModule } from '@angular/common/http';
import { HttpClientTestingModule } from '@angular/common/http/testing';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AutopropBackend } from './autoprop-backend';
import { API_ENDPOINT, WS_ENDPOINT } from './backend.config';
import { Response } from './response.model';
import { Task } from './task.model';
import { TasksService } from './tasks.service';
import { WebSocketMessage, WebSocketTaskResult } from './web-socket-message.model';
import { WebSocketService } from './web-socket.service';


export interface Config {
    apiEndpoint: string;
    wsEndpoint: string;
}

export {
    API_ENDPOINT,
    AutopropBackend,
    Response,
    Task,
    TasksService,
    WebSocketMessage,
    WebSocketService,
    WebSocketTaskResult,
    WS_ENDPOINT,
};

@NgModule({
    imports: [
        HttpClientModule,
    ],
})
export class BackendModule {

    static forRoot(config: Config): ModuleWithProviders<BackendModule> {
        return {
            ngModule: BackendModule,
            providers: [
                { provide: API_ENDPOINT, useValue: config.apiEndpoint },
                { provide: WS_ENDPOINT, useValue: config.wsEndpoint },
            ],
        };
    }
}


@NgModule({
    imports: [
        HttpClientTestingModule,
        BackendModule.forRoot({ apiEndpoint: 'https://api.example.com', wsEndpoint: 'wss://ws.example.com' }),
    ],
    providers: [
        { provide: WebSocketService, useValue: {} },
    ]
})
export class BackendTestingModule {}
